import { render, staticRenderFns } from "./application-data-refuse.vue?vue&type=template&id=9247e994&scoped=true"
import script from "./application-data-refuse.vue?vue&type=script&lang=ts"
export * from "./application-data-refuse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9247e994",
  null
  
)

export default component.exports